<template>
    <div class="antialiased">
        <Sidebar/>
        <div class="page">

            <Header @change="_search" hint="Ketik No Surat"/>
            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">
                                    Daftar Surat Konfirmasi Piutang
                                </h2>
                            </div>
                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto p-0">
                                        <div class="input-icon">
                                        <span class="input-icon-addon">
                                            <i class="fe fe-align-left"></i>
                                        </span>
                                        <select
                                            class="form-control"
                                            v-model="filters.per_page"
                                            @change="_getListSuratTagihan()"
                                            :disabled="loading"
                                        >
                                            <option
                                            :value="num"
                                            v-for="(num, i) in [10, 50, 100, 999]"
                                            :key="i"
                                            v-html="num == 999 ? 'Semua' : num"
                                            />
                                        </select>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <button class="btn btn-white mr-2" v-html="ic('filter')" @click="_openFilter" />
                                        <button class="btn btn-primary" @click="_openFormGenerateSuratTagihan">
                                            Tambah
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-body">
                        <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
                        <Nodata v-if="!loading && surat_tagihans.length === 0"/>
                        <div class="box" v-if="!loading && surat_tagihans.length > 0" >
                            <div class="card">
                                <div class="table-responsive">
                                    <table class="table table-vcenter table-hover card-table table-striped table-control">
                                        <thead>
                                            <tr class="text-muted">
                                                <th>No</th>
                                                <th>Perusahaan</th>
                                                <th>Depo</th>
                                                <th>No Surat</th>
                                                <th>Tanggal Surat</th>
                                                <th>Toko</th>
                                                <!-- <th>File</th> -->
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="(surat_tagihan, index) in surat_tagihans" :key="index">
                                                <td>{{ paginate.fromPage +index}}</td>
                                                <td>{{ surat_tagihan.nama_perusahaan }}</td>
                                                <td>{{ surat_tagihan.nama_depo }}</td>
                                                <td>{{ surat_tagihan.nomor_surat }}</td>
                                                <td>{{ surat_tagihan.tanggal_surat }}</td>
                                                <td>
                                                    [{{ surat_tagihan.no_acc }}]
                                                    <br>
                                                    {{ surat_tagihan.nama_toko }}
                                                </td>
                                                <!-- <td>{{ surat_tagihan.file_status }}</td> -->
                                                <td>
                                                    <b-dropdown variant="link" size="lg" dropleft no-caret>
                                                        <template slot="button-content">
                                                            <i class="fe fe-more-vertical"></i>
                                                        </template>
                                                        <b-dropdown-item @click="_openDetailSuratTagihan(surat_tagihan.id)">
                                                            Detail
                                                        </b-dropdown-item>
                                                        <b-dropdown-item @click="_printSuratTagihan(surat_tagihan.id)">
                                                            Print
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="container-fluid" v-if="surat_tagihans.length > 0">
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-auto text-center">
                                    <button class="btn btn-outline-primary mr-3" @click="_pagePrev">
                                    Prev
                                    </button>
                                    <button class="btn btn-outline-primary" @click="_pageNext">
                                    Next
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <FormGeneratePenagihan
                :isOpen.sync="modals.generate.view"
                @generateSuratTagihan="modals.generate.action"
            />
            <FormFilter
                :isOpen.sync="modals.filter.view"
                @submit="modals.filter.action"
            />

            <FormDetail
                :id="modals.detail_surat_tagihan.id"
                :isOpen.sync="modals.detail_surat_tagihan.view"
            />
        </div>
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormGeneratePenagihan from "./modals/form-generate-tagihan.vue";
import FormFilter from "./modals/filter.vue";
import FormDetail from "./modals/detail.vue";
import { mapState, mapActions } from 'vuex';

const now = new Date();
export default {
    name: "MenuSuratPenagihan",
    components: {FormGeneratePenagihan, FormFilter, FormDetail },
    data(){
        return {
            loading: false,
            modals:{
                generate:{
                    view: false,
                    action: () => {}
                },
                detail_surat_tagihan:{
                    id: '',
                    view: false,
                },
                filter:{
                    view: false,
                    action: () => {}
                }
            },
            paginate:{
                fromPage: 0,
                to: 0,
                total:0
            },
            filters:{
                ids_perusahaan: [],
                ids_depo: [],
                start_date: new Date(now.getFullYear(), now.getMonth() - 1, 2).toISOString().slice(0, 10),
                end_date: this.dateTime("ymd"),
                keyword: '',
                page:1, 
                per_page:10 , 
            }
        }
    },
    mixins: [helper],
    computed:{
        ...mapState('surat_tagihan', {
            surat_tagihans: state => state.datas.list,
        }),
    },
    methods: {
        ...mapActions("surat_tagihan", ["listSuratTagihan","generateSuratTagihan"]),

        async _getListSuratTagihan(){
            this.loading = true
            try {
                const response = await this.listSuratTagihan(this.filters);
                this.paginate.fromPage = response.meta.from;
                this.paginate.to = response.meta.to;
                this.paginate.total = response.meta.total;
            }catch (error) {
                console.log(error)
            }finally{
                this.loading = false
            }
        },

        _pagePrev() {
            if (this.filters.page > 1) {
                this.filters.page--;
                this._getListSuratTagihan();
            }
        },
        _pageNext() {
            console.log(this.filters.per_page)
            if (this.paginate.to % this.filters.per_page == 0) {
                this.filters.page++;
                this._getListSuratTagihan();
            }
        },

        _openFormGenerateSuratTagihan(){
            this.modals.generate.view = true
            this.modals.generate.action = async (payload) => {
                await this.generateSuratTagihan(payload)
                await this._getListSuratTagihan()
            }
        },
        _openFilter(){
            this.modals.filter.view = true
            this.modals.filter.action = (query) => {
                for (const key in query) {
                    this.filters[key] = query[key];
                }
                this._getListSuratTagihan()
            }
        },
        _openDetailSuratTagihan(id){
            this.modals.detail_surat_tagihan.id = id
            this.modals.detail_surat_tagihan.view = true
        },
        _printSuratTagihan(id){
            window.open(window.location.origin+`/dashboard/finance/surat-tagihan/${id}/print`, '_blank')
        },
        _search(keyword) {
            this.filters.keyword = keyword;
            this.filters.page = 1;
            this._getListSuratTagihan();
        },
    },
    mounted() {
        this._getListSuratTagihan()
    }

}
</script>
